export { default as ScrollLock } from './scroll-lock';
